module.exports = __webpack_public_path__ + "public/img/zlaq.7b1a2540.png";